import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'antd/dist/antd.less';
import App from './App';
import { Router, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';

// import Bugsnag from '@bugsnag/js'
// import BugsnagPluginReact from '@bugsnag/plugin-react'
import './views/views-dir.less';

// Bugsnag.start({
//     apiKey: '153661bbe487a39c166bfc652f5c3b98',
//     plugins: [new BugsnagPluginReact()]
// })

// const ErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React)

const globalScope = globalThis as typeof globalThis & {
    process?: {
        nextTick?: (callback: (...args: unknown[]) => void, ...args: unknown[]) => void;
    };
};

if (!globalScope.process) {
    globalScope.process = {};
}

if (typeof globalScope.process.nextTick !== 'function') {
    globalScope.process.nextTick = (callback: (...args: unknown[]) => void, ...args: unknown[]) => {
        Promise.resolve().then(() => callback(...args));
    };
}

ReactDOM.render( 
    // <ErrorBoundary>
        <Router history={createBrowserHistory()}>
            <Route component={App}/>
        </Router>
    // </ErrorBoundary>
, document.getElementById('root'));